export const ZIP_FILE='https://drive.google.com/file/d/12DL-NW-NmtADvCsFzIv_P1a7POthgusb/view?usp=sharing';
export const INSTALLER_FILE='https://drive.google.com/file/d/1iGn0iD2f30IKV8BaFeMuaBfa-MfmzkD-/view?usp=sharing';
export const VIDEO_URL='https://www.youtube-nocookie.com/embed/gMASrJRQxw4?rel=0';
